import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/product-pattern/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const ProductPatternStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.DISABLED] : 'danger',
    [STATUS.ENABLED]  : 'success'

  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

ProductPatternStatusBadge.propTypes = propTypes

export default ProductPatternStatusBadge
